<template>
  <div class="index-box">
    <!-- 优秀校友 -->
    <van-list
      v-if="hommieList != ''"
      class="listBoxVan"
      :immediate-check="false"
      v-model="loading"
      :finished="alumnFinished"
      finished-text="没有更多了"
      @load="alumniOnLoad"
    >
      <div class="alumnlistBox">
        <div
          class="RepresentativeListCard"
          v-for="(item, index) in hommieList"
          :key="index"
          @click="gotoHommieDetal(item)"
        >
          <div class="card-list__itemone">
            <img class="headDiagram" :src="item.img" />
          </div>
          <div class="card-list__itemtwo">
            <span class="DynamicTitle">{{ item.schoolName }}</span>
            <span class="DynamicTitle-x">地点：{{ item.address }}</span>
            <span class="DynamicDate ellipsis-multiline">{{
              item.updateAt
            }}</span>
          </div>
        </div>
      </div>
    </van-list>
  </div>
</template>

<script>
export default {
  data() {
    return {
      hommieList: [],
      index: 2,
      page: 1,
      pageIndex: 1,
      pageSize: 5,
      loading: false,
      finished: false,
      alumnFinished: false,
      lastPage: "",
      alumniLastPage: "",
    };
  },
  created() {
    this.getHommie();
  },
  methods: {
    
    async getHommie() {
      const result = await this.$http.get("/schoolhome/listByPage", {
        params: { pageIndex: this.pageIndex, pageSize: this.pageSize },
      });
      for (let i = 0; i < result.data.list.length; i++) {
        this.hommieList.push(result.data.list[i]);
      }
      this.alumniLastPage = result.data.lastPage;
    },

    alumniOnLoad() {
      this.page = 1;
      this.pageIndex = this.pageIndex + 1;
      this.getHommie();
      this.loading = false;
      // 数据全部加载完成
      if (this.pageIndex >= this.alumniLastPage) {
        this.alumnFinished = true;
      }
    },

    // 杰出校友--详情
    gotoHommieDetal(item) {
      return this.$router.push({
        path: "/hommieDetail",
        query: {
          id: item.id,
        },
      });
    },
  },
};
</script>
<style lang="less" scoped>
.index-box {
  position: relative;
  .infdex-top {
    position: fixed;
    top: 45px;
    left: 0;
    z-index: 999;
    width: 100vw;
    height: 50px;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    .index-top-left {
      width: 50vw;
      height: 50px;
      background: #edf6f3;
      color: #067371;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      font-size: 1.1rem;
      font-weight: 600;
      .index-top-left-line {
        width: 30px;
        height: 3px;
        background: #067371;
        margin-top: 3px;
      }
    }
    .index-top-right {
      width: 50vw;
      height: 50px;
      background: #edf6f3;
      color: #9e9e9e;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      font-size: 1.1rem;
      font-weight: 600;
      .index-top-right-line {
        width: 30px;
        height: 3px;
        background: #9e9e9e;
        opacity: 0;
        margin-top: 3px;
      }
    }
  }

  .listBoxVan {
    position: relative;
    .listBox {
      width: 100vw;
      display: flex;
      flex-direction: column;
      margin-bottom: 10px;
      .RepresentativeListCard {
        display: flex;
        width: 110vw;
        background: #fff;
        border-radius: 0.5rem;
        height: 7rem;
        margin-left: 2.5vw;
        margin-top: 10px;
        .card-list__itemone {
          flex: 1;
          width: 30%;
          margin: 5px 0 5px 5px;
          // margin-left: 5px;
          // border: 1px solid #181616;
          .headDiagram {
            position: relative;
            width: 60%;
            height: 100%;
            z-index: 0;
            border-radius: 10px;
            background-size: 100% 100%;
            image-rendering: -webkit-optimize-contrast;
          }
        }
        .card-list__itemtwo {
          flex: 2;
          margin: 0px 3px 5px 5px;
          display: flex;
          flex-direction: column;
          .DynamicTitle {
            position: relative;
            margin: 5px 5px 0 5px;
            font-size: 1.1rem;
            font-weight: 600;
          }

          .DynamicTitle-x {
            width: 60%;
            word-wrap: break-word;
            position: relative;
            margin: 5px 5px 0 5px;
            font-size: 1rem;
            color: #727272;
            overflow: hidden;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-line-clamp: 1;
            -webkit-box-orient: vertical;
          }
          .DynamicDate {
            margin-top: 5px;
            padding-left: 5px;
            font-size: 0.85rem;
            color: #a9a9a9;
            width: 58vw;
            line-height: 20px;
            text-align: justify;
          }
          .ellipsis-multiline {
            line-height: 25px; //行间距
            // text-indent: 4ch;//首行缩进
            text-align: justify; //两端对齐
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 4;
            overflow: hidden;
            text-overflow: ellipsis;
          }
        }
      }
    }

    .alumnlistBox {
      width: 100vw;
      display: flex;
      flex-direction: column;
      margin-bottom: 20px;
      .RepresentativeListCard {
        display: flex;
        width: 95vw;
        background: #fff;
        border-radius: 0.5rem;
        height: 11rem;
        margin-left: 2.5vw;
        margin-top: 10px;
        .card-list__itemone {
          flex: 1;
          width: 30vw;
          margin: 5px 0 5px 5px;
          // margin-left: 5px;
          // border: 1px solid #181616;
          .headDiagram {
            position: relative;
            width: 95%;
            height: 100%;
            z-index: 0;
            border-radius: 10px;
            background-size: 100% 100%;
            image-rendering: -webkit-optimize-contrast;
          }
        }
        .card-list__itemtwo {
          flex: 2;
          margin: 0px 3px 5px 5px;
          display: flex;
          flex-direction: column;
          .DynamicTitle {
            position: relative;
            margin: 5px 5px 0 5px;
            font-size: 1.1rem;
            font-weight: 600;
          }

          .DynamicTitle-x {
            position: relative;
            margin: 5px 5px 0 5px;
            font-size: 1rem;
            color: #727272;
            overflow: hidden;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-line-clamp: 1;
            -webkit-box-orient: vertical;
          }
          .DynamicDate {
            margin-top: 5px;
            padding-left: 5px;
            font-size: 0.85rem;
            color: #a9a9a9;
            width: 58vw;
            line-height: 20px;
            text-align: justify;
          }
          .ellipsis-multiline {
            line-height: 25px; //行间距
            // text-indent: 4ch;//首行缩进
            text-align: justify; //两端对齐
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 4;
            overflow: hidden;
            text-overflow: ellipsis;
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/hommie/List.vue